import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/Classical_Antiquity_-_Ancient_Rome.png';

function HistoryPageRomeGo() {
  return (
    <QuizPage
      title="History: Ancient Rome"
      subTopic="Ancient Rome"
      backgroundImage={historyImage}
      returnPath="/History-Ancient-Rome"
    />
  );
}

export default HistoryPageRomeGo;   


